<template>
    <div class="apprentice-simple-card">
        <div class="row" style="display: none;">
            <design-2021-digistudies-search></design-2021-digistudies-search>
        </div>

        <design-2021-digitalstudies-subjects-grid
            :digitalstudiesdisciplines="digitalstudiesdisciplines"
        >
        </design-2021-digitalstudies-subjects-grid>

    </div>
</template>

<script>
export default {
    name: "design-2021-digistudies-discpline-component",
    props:[
        'digitalstudiesdisciplines'
    ]
}
</script>

<style scoped>

</style>
